(function () {
  "use strict";

  if (window.__jelriWizzCartIntegrity20260804) return;
  window.__jelriWizzCartIntegrity20260804 = true;

  var DRAWER_SELECTOR = ".wizz4-cart-drawer";
  var PRODUCT_SELECTOR = ".wizz-product-custom";
  var CACHE_TTL_MS = 650;
  var REQUEST_TIMEOUT_MS = 4500;
  var FREE_SHIPPING_THRESHOLD = 2;
  var observedDrawers = new WeakSet();
  var scheduledTimers = new Set();
  var uniqueIdCounter = 1;
  var state = {
    cart: null,
    readAt: 0,
    inFlight: null
  };

  function recordError(error) {
    var errors = window.__jelriWizzCartIntegrityErrors || [];
    errors.push({
      message: error && error.message ? error.message : String(error),
      at: new Date().toISOString()
    });
    window.__jelriWizzCartIntegrityErrors = errors.slice(-20);
  }

  function normalizeCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    if (typeof cart.item_count !== "number") {
      cart.item_count = cart.items.reduce(function (total, item) {
        return total + Number(item.quantity || 0);
      }, 0);
    }
    return cart;
  }

  function readCart() {
    if (state.inFlight) return state.inFlight;
    if (state.cart && Date.now() - state.readAt < CACHE_TTL_MS) {
      return Promise.resolve(state.cart);
    }

    state.inFlight = new Promise(function (resolve, reject) {
      var request = new XMLHttpRequest();
      request.open("GET", "/cart.js?jelri_integrity=" + encodeURIComponent(Date.now()), true);
      request.timeout = REQUEST_TIMEOUT_MS;
      request.setRequestHeader("Accept", "application/json");
      request.onload = function () {
        if (request.status < 200 || request.status >= 300) {
          reject(new Error("Cart read failed: " + request.status));
          return;
        }
        try {
          resolve(normalizeCart(JSON.parse(request.responseText)));
        } catch (error) {
          reject(error);
        }
      };
      request.onerror = function () { reject(new Error("Cart read failed")); };
      request.ontimeout = function () { reject(new Error("Cart read timed out")); };
      request.onabort = function () { reject(new Error("Cart read aborted")); };
      request.send();
    }).then(function (cart) {
      state.cart = cart;
      state.readAt = Date.now();
      state.inFlight = null;
      return cart;
    }, function (error) {
      state.inFlight = null;
      throw error;
    });

    return state.inFlight;
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(Number(cents || 0) / 100).replace("$", "MXN ");
    } catch (error) {
      return "MXN " + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function variantIdFromLine(line) {
    var link = line && line.querySelector('a[href*="variant="]');
    if (!link) return null;
    try {
      var id = Number(new URL(link.getAttribute("href"), window.location.href).searchParams.get("variant"));
      return Number.isFinite(id) ? id : null;
    } catch (error) {
      return null;
    }
  }

  function cartItemForLine(cart, line, index) {
    var variantId = variantIdFromLine(line);
    if (variantId) {
      var matched = cart.items.find(function (item) {
        return Number(item.id || item.variant_id) === variantId;
      });
      if (matched) return matched;
    }
    return cart.items[index] || null;
  }

  function setText(node, value) {
    if (node && node.textContent !== value) node.textContent = value;
  }

  function syncLine(line, item) {
    if (!line || !item) return;
    var quantity = Math.max(0, Number(item.quantity || 0));
    var input = line.querySelector(".wizz-product-content-buttonGroup-custom input, input");
    if (input && input.value !== String(quantity)) input.value = String(quantity);

    var original = Number(item.original_line_price || item.line_price || 0);
    var finalPrice = Number(item.final_line_price || item.line_price || 0);
    var saving = Math.max(0, original - finalPrice);

    line.querySelectorAll(".wizz-product-price-originalPrice-custom").forEach(function (node) {
      setText(node, money(original));
    });
    line.querySelectorAll(".wizz-product-price-Price-custom").forEach(function (node) {
      setText(node, money(finalPrice));
    });
    line.querySelectorAll(".wizz-product-price-saving-custom").forEach(function (node) {
      setText(node, saving > 0 ? "Ahorro " + money(saving) : "");
    });
  }

  function syncProductLines(cart, drawer) {
    var lines = Array.prototype.slice.call(drawer.querySelectorAll(PRODUCT_SELECTOR));
    lines.forEach(function (line, index) {
      var item = cartItemForLine(cart, line, index);
      if (!item || Number(item.quantity || 0) <= 0) {
        line.remove();
        return;
      }
      syncLine(line, item);
    });
  }

  function updateHeaderCount(count) {
    document.querySelectorAll("[data-cart-count]").forEach(function (node) {
      node.setAttribute("data-cart-count", String(count));
      if (/^\s*\d+\s*$/.test(node.textContent || "")) setText(node, String(count));
    });
  }

  function syncRewardBar(cart, drawer) {
    var count = Math.max(0, Number(cart.item_count || 0));
    var remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - count);
    var progress = Math.max(0, Math.min(1, count / FREE_SHIPPING_THRESHOLD));
    var message = remaining === 0
      ? "🎉 ¡Felicidades! Has obtenido envío gratis 🚚"
      : "Te faltan " + remaining + " pieza" + (remaining === 1 ? "" : "s") + " para obtener envío gratis.";

    drawer.querySelectorAll(".wizz-rewardbar-title").forEach(function (node) {
      setText(node, message);
    });
    drawer.querySelectorAll(".wizz-rewardbar-progress").forEach(function (node) {
      node.style.setProperty("--jelri-reward-progress", String(progress));
    });
    drawer.querySelectorAll(".wizz-rewardbar-description").forEach(function (node) {
      setText(node, "Envío gratis");
    });
  }

  function setCheckoutLabel(drawer, cart) {
    var label = "Finalizar compra - " + money(cart.total_price || cart.items_subtotal_price);
    drawer.querySelectorAll(".wizz-checkout-button").forEach(function (button) {
      var content = button.querySelector(".w4-flex, span, div");
      setText(content || button, label);
    });
  }

  function replaceVisibleCopy(drawer) {
    drawer.querySelectorAll("span, p, button, [class*='announcement'], [class*='header-title']").forEach(function (node) {
      if (node.children.length) return;
      var current = (node.textContent || "").trim();
      var next = current
        .replace(/Entrega rápida de 2 a 5 días(?: hábiles)?/gi, "Entrega de 3 a 8 días hábiles")
        .replace(/^Your cart\b/i, "Tu carrito")
        .replace(/^Checkout$/i, "Finalizar compra")
        .replace(/^Clear cart$/i, "Vaciar carrito");
      if (next !== current) setText(node, next);
    });
  }

  function titleForUpsellLink(link) {
    var scope = link.parentElement;
    while (scope && !scope.matches(DRAWER_SELECTOR)) {
      var title = scope.querySelector(".wizz-upsell-productInfor-content-title-custom");
      if (title && title.textContent.trim()) return title.textContent.trim();
      scope = scope.parentElement;
    }
    return "producto recomendado";
  }

  function improveAccessibility(drawer) {
    drawer.querySelectorAll(".wizz-upsell-productInfor-img-custom").forEach(function (link) {
      var title = titleForUpsellLink(link);
      link.setAttribute("aria-label", "Ver " + title);
      var image = link.querySelector("img");
      if (image && !image.getAttribute("alt")) image.setAttribute("alt", title);
    });

    drawer.querySelectorAll("select").forEach(function (select) {
      if (!select.getAttribute("aria-label") && !select.getAttribute("aria-labelledby")) {
        select.setAttribute("aria-label", "Talla");
      }
    });
    drawer.querySelectorAll(".wizz-header-icon-custom").forEach(function (button) {
      button.setAttribute("aria-label", "Cerrar carrito");
      button.setAttribute("role", "button");
      button.setAttribute("tabindex", "0");
    });
    drawer.querySelectorAll(".wizz-product-content-buttonGroup-decr-custom").forEach(function (button) {
      button.setAttribute("aria-label", "Disminuir cantidad");
      if (button.tagName !== "BUTTON") {
        button.setAttribute("role", "button");
        button.setAttribute("tabindex", "0");
      }
    });
    drawer.querySelectorAll(".wizz-product-content-buttonGroup-incr-custom").forEach(function (button) {
      button.setAttribute("aria-label", "Aumentar cantidad");
      if (button.tagName !== "BUTTON") {
        button.setAttribute("role", "button");
        button.setAttribute("tabindex", "0");
      }
    });
    drawer.querySelectorAll(".wizz-product-price-deleteIcon-custom").forEach(function (button) {
      button.setAttribute("aria-label", "Eliminar producto del carrito");
      button.setAttribute("role", "button");
      button.setAttribute("tabindex", "0");
    });
  }

  function makeWizzIdsUnique(drawer) {
    [
      "w4-select-upsell",
      "w4-storefront-item",
      "w4-storefront-item-img",
      "product-review-wizz",
      "product-saving-wizz"
    ].forEach(function (baseId) {
      var nodes = Array.prototype.slice.call(document.querySelectorAll("#" + baseId));
      nodes.slice(1).forEach(function (node) {
        var candidate;
        do {
          uniqueIdCounter += 1;
          candidate = baseId + "-jelri-" + uniqueIdCounter;
        } while (document.getElementById(candidate));
        node.id = candidate;
      });
    });
  }

  function repairHiddenOmnisendIds() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll(
      '[id^="omnisend-form-"][id$="-promotional-form"]'
    ));
    var groups = {};
    nodes.forEach(function (node) {
      var id = node.id;
      groups[id] = groups[id] || [];
      groups[id].push(node);
    });
    Object.keys(groups).forEach(function (id) {
      groups[id].slice(1).forEach(function (node) {
        var candidate;
        do {
          uniqueIdCounter += 1;
          candidate = id + "-state-" + uniqueIdCounter;
        } while (document.getElementById(candidate));
        node.id = candidate;
      });
    });
  }

  function syncDrawer(cart, drawer) {
    replaceVisibleCopy(drawer);
    improveAccessibility(drawer);
    makeWizzIdsUnique(drawer);
    syncProductLines(cart, drawer);
    syncRewardBar(cart, drawer);
    setCheckoutLabel(drawer, cart);

    drawer.querySelectorAll(".wizz-header-title-custom").forEach(function (title) {
      if (/\(\s*\d+\s*\)/.test(title.textContent || "")) {
        setText(title, title.textContent.replace(/\(\s*\d+\s*\)/, "(" + cart.item_count + ")"));
      }
    });
  }

  function sync(cart) {
    var drawers = Array.prototype.slice.call(document.querySelectorAll(DRAWER_SELECTOR));
    if (!drawers.length) return Promise.resolve(null);
    var supplied = normalizeCart(cart);
    var promise = supplied ? Promise.resolve(supplied) : readCart();
    return promise.then(function (canonicalCart) {
      drawers.forEach(function (drawer) {
        observeDrawer(drawer);
        syncDrawer(canonicalCart, drawer);
      });
      updateHeaderCount(canonicalCart.item_count);
      return canonicalCart;
    }).catch(function (error) {
      recordError(error);
      return null;
    });
  }

  function schedule(cart, delays) {
    (delays || [0, 500, 1500]).forEach(function (delay) {
      var timer = window.setTimeout(function () {
        scheduledTimers.delete(timer);
        repairHiddenOmnisendIds();
        document.querySelectorAll(DRAWER_SELECTOR).forEach(observeDrawer);
        sync(cart || (state.readAt > 0 ? state.cart : null));
      }, delay);
      scheduledTimers.add(timer);
    });
  }

  function observeDrawer(drawer) {
    if (!drawer || observedDrawers.has(drawer)) return;
    observedDrawers.add(drawer);
    var queued = false;
    new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
          return node && node.nodeType === 1 && (
            node.matches(PRODUCT_SELECTOR + ", .wizz-checkout-button, .wizz-rewardbar-progress, .wizz-upsell-productInfor-img-custom, [id='w4-select-upsell']") ||
            (node.querySelector && node.querySelector(PRODUCT_SELECTOR + ", .wizz-checkout-button, .wizz-rewardbar-progress, .wizz-upsell-productInfor-img-custom, [id='w4-select-upsell']"))
          );
        });
      });
      if (!relevant || queued) return;
      queued = true;
      window.setTimeout(function () {
        queued = false;
        state.readAt = 0;
        sync(null);
      }, 180);
    }).observe(drawer, { childList: true, subtree: true });
  }

  document.addEventListener("click", function (event) {
    if (event.target.closest(
      ".wizz-product-content-buttonGroup-decr-custom, " +
      ".wizz-product-content-buttonGroup-incr-custom, " +
      ".header__icon--cart, .styles_snapCartStickyButton"
    )) {
      state.readAt = 0;
      schedule(null, [180, 700, 1600]);
    }
  }, true);

  document.addEventListener("keydown", function (event) {
    var control = event.target.closest && event.target.closest(
      ".wizz-header-icon-custom[role='button'], " +
      ".wizz-product-content-buttonGroup-decr-custom[role='button'], " +
      ".wizz-product-content-buttonGroup-incr-custom[role='button'], " +
      ".wizz-product-price-deleteIcon-custom[role='button']"
    );
    if (!control || (event.key !== "Enter" && event.key !== " ")) return;
    event.preventDefault();
    control.click();
  }, true);

  document.addEventListener("cart:updated", function (event) {
    var cart = event.detail && event.detail.cart;
    state.readAt = 0;
    schedule(cart, [0, 300, 900]);
  });
  window.addEventListener("cart_changed", function () {
    state.readAt = 0;
    schedule(null, [150, 700, 1600]);
  });

  schedule(null, [600, 1600, 3200, 6000, 10000, 15000]);
})();
